export function checkIsDigitsPrefixedWithPlus(phoneNumber: string): boolean {
  if (!phoneNumber) {
    return true;
  }
  if (phoneNumber.trim() === '+') {
    return true;
  }
  const phoneRegex = new RegExp('^(?:[+\\d].*\\d|\\d)$');
  return phoneRegex.test(phoneNumber);
}
